import {
    ApiParameter,
    get,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

const requestSystemListUrl = "api/sainc/systemList?name";

export interface RequestSystemListModel {
    slug: string;
    values?: Array<any>;
}

export interface RequestSystemListApiParameter extends ApiParameter {
    url: Partial<RequestSystemListModel>;
}

export async function requestSystemList(parameter: RequestSystemListApiParameter): Promise<ServiceResult<RequestSystemListModel>> {
    try {

        const requestSystemListModel = await get<RequestSystemListModel>(`${requestSystemListUrl}=${parameter.url.slug}`);
        return {
            result: requestSystemListModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: ((error as any)?.errorJson?.message),
        };
    }
}